const driver_license =`Ajokortti on tärkeä kaikille.
Suomessa, kuten monissa muissakin maissa, ajokortti myönnetään 18-vuotiaana.
Henkilökohtaisesti uskon, että on hyvä ikä hankkia lisenssi,
koska se auttaa meitä ajamaan autoa ja liikkumaan vapaasti.
Sama on minunkin maassani, saat ajokortin 18-vuotiaana.
Yläikärajan sijaan voisimme peruuttaa ajokortin,
kun henkilön terveys ei enää salli hänen ajaa turvallisesti.
Ajokoe on suomea yksinkertaisempi ja myös halvempi.
Ajokortin saamiseksi sinun on opittava liikennesäännöt ja kuinka ajaa turvallisesti.
Asioiden parantamiseksi voimme muuttaa tapoja, joilla ihmiset saavat ajokorttinsa.
Voisimme asentaa joitain uusia laitteita käyttäjän autoon ja valvoa niiden suorituskykyä tiellä.
Sen perusteella voimme päättää, tarvitseeko lisenssi peruuttaa.
Tämä voi auttaa tekemään teistämme turvallisempia kaikille.`;

export default driver_license;